import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import useTranslate from '../../customHooks/useTranslate';
import Icon from '../../muiComponents/Icon';
import Title from '../../property-partners-portal/components/Title';

interface IconAndTextComponentProps {
    icon: string;
    text: string | string[];
    description: string;
    fontWeight?: number;
    titleButtonbar?: React.ReactNode;
}

const IconAndTextComponent = ({
    icon,
    text,
    description,
    fontWeight = 400,
    titleButtonbar,
}: IconAndTextComponentProps) => {
    const translate = useTranslate();
    const isArray = Array.isArray(text);
    const textToDisplay = isArray && text.length ? text.join(', ') : text;
    return (
        <div className='icon-and-text__container'>
            <span className='flex gap-8 flex-align-center'>
                <Icon iconName={icon} className='text-primary-400' />
                <Title className='width-content'>
                    {translate(description)}
                </Title>
                {titleButtonbar}
            </span>

            <Tooltip title={translate(description)} placement='top'>
                <div
                    className='width-content text-overflow-ellipsis'
                    style={{ fontWeight: fontWeight, maxWidth: '100%' }}
                >
                    {textToDisplay || '----'}
                </div>
            </Tooltip>
        </div>
    );
};

export default IconAndTextComponent;
